// 好快测试
// const path = "https://test.hooook.com";
// 好快测试后台
// const path2 = "http://test-px.hysz.co:8080/front";

// 汉阳测试H5
// export const path = "https://test-train.hysz.co/front-mobile";
// 汉阳测试后台
// export const path2 = "https://test-train.hysz.co/front-pc";

// 汉阳正式H5
export const path = "https://px.hysz.co/front-mobile";
// 汉阳正式后台
export const path2 = "https://px.hysz.co/front-pc";
